// extracted by mini-css-extract-plugin
export default {"DomainCustomizationWrapper":"vNC3F99vDh3C9fZtjR2TFw==","TitleAndDescription":"nfFPSnsj6inLi1UdOHpDoA=="};